const dpdParcelshopAdminValidation = (function () {
	let disallowShopsCheckbox,
		disallowLockersCheckbox,
		disallowDpdPickupStationsCheckbox,
		disallowSkPostCheckbox,
		disallowAlzaBoxesCheckbox,
		disallowZboxCheckbox;

	/**
	 * Validate that at least one pickup point type remains enabled
	 */
	function validatePickupPointTypes(changedCheckbox) {
		// Check if all individual locker types are disabled
		const allIndividualLockersDisabled =
			disallowDpdPickupStationsCheckbox &&
			disallowDpdPickupStationsCheckbox.checked &&
			disallowSkPostCheckbox &&
			disallowSkPostCheckbox.checked &&
			disallowAlzaBoxesCheckbox &&
			disallowAlzaBoxesCheckbox.checked &&
			disallowZboxCheckbox &&
			disallowZboxCheckbox.checked;

		// If shops are disabled AND (global lockers are disabled OR all individual lockers are disabled)
		if (
			disallowShopsCheckbox.checked &&
			(disallowLockersCheckbox.checked || allIndividualLockersDisabled)
		) {
			changedCheckbox.checked = false;

			alert(
				'Aspoň jeden typ odberného miesta musí zostať povolený. Nemôžete zakázať obchody a všetky typy boxov súčasne.'
			);

			return false;
		}

		return true;
	}

	/**
	 * Validate that we cannot have global lockers disabled and all individual locker types disabled
	 */
	function validateLockerConfiguration(changedCheckbox) {
		// Check if all individual locker types are disabled
		const allIndividualLockersDisabled =
			disallowDpdPickupStationsCheckbox &&
			disallowDpdPickupStationsCheckbox.checked &&
			disallowSkPostCheckbox &&
			disallowSkPostCheckbox.checked &&
			disallowAlzaBoxesCheckbox &&
			disallowAlzaBoxesCheckbox.checked &&
			disallowZboxCheckbox &&
			disallowZboxCheckbox.checked;

		// If trying to disable global lockers when all individual types are already disabled
		if (disallowLockersCheckbox.checked && allIndividualLockersDisabled) {
			changedCheckbox.checked = false;

			alert(
				'Nemôžete mať zakázané všetky samoobslužné boxy globálne a zároveň aj všetky jednotlivé typy boxov. Táto konfigurácia je nadbytočná.'
			);

			return false;
		}

		return true;
	}

	function init() {
		disallowShopsCheckbox = document.querySelector(
			'.js-dpd-disallow-shops-checkbox'
		);
		disallowLockersCheckbox = document.querySelector(
			'.js-dpd-disallow-lockers-checkbox'
		);
		disallowDpdPickupStationsCheckbox = document.querySelector(
			'.js-dpd-disallow-dpd-pickup-stations-checkbox'
		);
		disallowSkPostCheckbox = document.querySelector(
			'.js-dpd-disallow-sk-post-checkbox'
		);
		disallowAlzaBoxesCheckbox = document.querySelector(
			'.js-dpd-disallow-alza-boxes-checkbox'
		);
		disallowZboxCheckbox = document.querySelector(
			'.js-dpd-disallow-zbox-checkbox'
		);

		if (!disallowShopsCheckbox || !disallowLockersCheckbox) {
			return;
		}

		/**
		 * Listen for changes on disallow shops checkbox
		 */
		disallowShopsCheckbox.addEventListener('change', function (e) {
			validatePickupPointTypes(e.target);
		});

		/**
		 * Listen for changes on disallow lockers checkbox
		 */
		disallowLockersCheckbox.addEventListener('change', function (e) {
			if (!validatePickupPointTypes(e.target)) {
				return;
			}
			validateLockerConfiguration(e.target);
		});

		// Add validation for individual locker type checkboxes if they exist
		if (
			disallowDpdPickupStationsCheckbox &&
			disallowSkPostCheckbox &&
			disallowAlzaBoxesCheckbox &&
			disallowZboxCheckbox
		) {
			/**
			 * Listen for changes on individual locker type checkboxes
			 */
			disallowDpdPickupStationsCheckbox.addEventListener(
				'change',
				function (e) {
					if (!validatePickupPointTypes(e.target)) {
						return;
					}
					validateLockerConfiguration(e.target);
				}
			);

			disallowSkPostCheckbox.addEventListener('change', function (e) {
				if (!validatePickupPointTypes(e.target)) {
					return;
				}
				validateLockerConfiguration(e.target);
			});

			disallowAlzaBoxesCheckbox.addEventListener('change', function (e) {
				if (!validatePickupPointTypes(e.target)) {
					return;
				}
				validateLockerConfiguration(e.target);
			});

			disallowZboxCheckbox.addEventListener('change', function (e) {
				if (!validatePickupPointTypes(e.target)) {
					return;
				}
				validateLockerConfiguration(e.target);
			});
		}
	}

	return {
		init: init,
	};
})();

export default dpdParcelshopAdminValidation;
